import React from "react";

const Resume = () => {
  return (
    <div className="resume-container">
      <h2>Resume</h2>
      <p>
        Here is a link to my resume:{" "}
        <a
          href="https://docs.google.com/document/d/1_guEPyDYYzEfiqnQmwRzKC1F2VmPse2Gyr3N4454bMo/edit?tab=t.0"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click Here
        </a>
      </p>
      </div>
  )}

export default Resume;